module.exports = __webpack_public_path__ + "img/NG.9586654a.svg";